











































































































import {
  QPage,
  QPageSticky,
  QBtn,
  QCard,
  QToolbar,
  QToolbarTitle,
  QHeader,
  QChatMessage,
  QIcon,
} from "quasar";
import { defineComponent, reactive, ref, watch } from "@vue/composition-api";
import { AIRequest, AIResponse, sendMessage } from "@/data/repos/aiassistant";
import { fetchUserInfo } from "@/modules/auth";
import { UserSessionResponse } from "@/data/repos/userInfo";
import router from "@/router";
import { MediaRecorder, register } from "extendable-media-recorder";
import { connect } from "extendable-media-recorder-wav-encoder";

let mediaRecorder: any = null;
// eslint-disable-next-line no-undef
let audioBlobs: Blob[] | MediaSource[] | BlobPart[] = [];
let capturedStream: any = null;

// Register the extendable-media-recorder-wav-encoder
setTimeout(async () => {
  await register(await connect());
});
const recordingInProgress = ref(false);
// Starts recording audio
function startRecording() {
  return navigator.mediaDevices
    .getUserMedia({
      audio: {
        echoCancellation: true,
      },
    })
    .then((stream) => {
      audioBlobs = [];
      capturedStream = stream;

      // Use the extended MediaRecorder library
      mediaRecorder = new MediaRecorder(stream, {
        mimeType: "audio/wav",
      });

      // Add audio blobs while recording
      mediaRecorder.addEventListener("dataavailable", (event: any) => {
        audioBlobs.push(event.data);
      });

      mediaRecorder.start();
    })
    .catch((e) => {
      console.error(e);
    });
}

function stopRecording() {
  return new Promise((resolve) => {
    if (!mediaRecorder) {
      resolve(null);
      return;
    }

    mediaRecorder.addEventListener("stop", () => {
      const { mimeType } = mediaRecorder;
      // eslint-disable-next-line no-undef
      const audioBlob = new Blob(audioBlobs as BlobPart[], { type: mimeType });

      if (capturedStream) {
        capturedStream.getTracks().forEach((track: any) => track.stop());
      }

      resolve(audioBlob);
    });

    mediaRecorder.stop();
  });
}

async function uploadRecording(audioBlob: any, fileType: any) {
  const formData = new FormData();
  formData.append("audio_data", audioBlob, "recording");
  formData.append("type", fileType || "mp3");

  // Your server endpoint to upload audio:
  const apiUrl = "https://mac-alpha.micadpro.net/api/voice";

  const response = await fetch(apiUrl, {
    method: "POST",
    cache: "no-cache",
    body: formData,
  });

  return response.json();
}

export default defineComponent({
  components: {
    QPage,
    QPageSticky,
    QBtn,
    QCard,
    QToolbar,
    QToolbarTitle,
    QHeader,
    QChatMessage,
    QIcon,
  },
  props: {
    app: String,
  },
  setup(props) {
    function send() {
      if (!state.message) return;
      const msg = {
        url: window.location.href,
        app: props.app,
        context: router.currentRoute.name || "",
        args: {
          userId: state.userInfo.userId,
          userName: state.userInfo.userName,
        },
        message: state.message,
      } as AIRequest;
      state.messages = [];
      state.messages.push({ text: state.message, sent: true });
      state.message = "";
      if (msg.context === "Home") msg.context = "Users";
      sendMessage(msg).then((resp) => {
        if (resp.ok && resp.payload)
          state.messages.push({ text: resp.payload.response, sent: false });
        else
          state.messages.push({ text: "Sorry, server failed.", sent: false });
      });
    }

    const state = reactive({
      showAssistant: false,
      message: "",
      userInfo: {} as UserSessionResponse,
      messages: [
        // { text: "hello", sent: true },
        // { text: "hello", sent: false },
        // { text: "hello", sent: true },
        // { text: "hello", sent: false },
        // { text: "hello", sent: true },
        // { text: "hello", sent: false },
        // { text: "hehlo", sent: true },
      ] as { text: string; sent: boolean }[],
      recordingInProgress,
      send,
    });
    fetchUserInfo().then((resp) => (state.userInfo = resp));
    watch(
      () => recordingInProgress.value,
      async (rip) => {
        if (rip) startRecording();
        else {
          await stopRecording();
          // saveBlob(audioBlobs[audioBlobs.length - 1], 'recording.wav')
          uploadRecording(audioBlobs[audioBlobs.length - 1], "wav")
            .then((resp) => {
              state.message = resp.transcript || "Error 1";
              send();
            })
            .catch(() => (state.message = "Error 2"));
        }
      }
    );

    return state;
  },
});
